import { css } from "@emotion/react";

export const styles = {
  disabled: css`
    pointer-events: none;
    cursor: default;
    opacity: 0.5;
  `
};
